import React, { Fragment, useCallback, useEffect, useState } from "react";
import BottomSheet, {
  BottomSheetBackdrop,
  BottomSheetBackdropProps,
  BottomSheetView,
} from "@gorhom/bottom-sheet";
import { Pressable, Text, useWindowDimensions, View } from "react-native";
import { useSheet } from "../shared/sheet-provider";
import CloseIcon from "@/assets/svgs/close-icon";
import { remapProps } from "react-native-css-interop";
import { SheetIds } from "../utils/sheet-ids";
import useResponsiveWidth from "@/elements/hooks/use-responsive-width";

remapProps(BottomSheetView, {
  className: "style",
});

remapProps(BottomSheet, {
  className: "containerStyle",
});

export type AdditionalLearningSheetPayload = {
  additionalLearningNeeds?: string;
};

export type AdditionalLearningSheetResult = void;

function AdditionalLearningSheet() {
  const [shouldRender, setShouldRender] = useState(false);
  const { register, close, dismiss, sheet } = useSheet<
    AdditionalLearningSheetPayload,
    AdditionalLearningSheetResult
  >(SheetIds.ADDITIONAL_LEARNING);
  const responsiveWidth = useResponsiveWidth();
  const { additionalLearningNeeds } = sheet?.payload ?? {};
  const { width } = useWindowDimensions();
  const marginLeft = (width - responsiveWidth) / 2;

  useEffect(() => {
    setShouldRender(true);
  }, []);

  const setBottomSheetRef = useCallback(
    (ref: BottomSheet | null) => {
      if (ref) {
        const refObject = { current: ref };
        register(refObject);
      }
    },
    [register]
  );

  const handleSheetChanges = useCallback(
    (index: number) => {
      if (index === -1) {
        dismiss();
      }
    },
    [dismiss]
  );

  const onClose = useCallback(async () => {
    close();
  }, [close]);

  const renderBackdrop = useCallback(
    (props: BottomSheetBackdropProps) => (
      <BottomSheetBackdrop
        {...props}
        disappearsOnIndex={-1}
        appearsOnIndex={0}
        onPress={onClose}
      />
    ),
    [onClose]
  );

  return shouldRender ? (
    <BottomSheet
      ref={setBottomSheetRef}
      backdropComponent={renderBackdrop}
      enablePanDownToClose
      index={-1}
      handleComponent={() => <Fragment />}
      onChange={handleSheetChanges}
      backgroundStyle={{
        backgroundColor: "#FCF9F5",
      }}
      containerStyle={{ width: responsiveWidth, marginLeft: marginLeft }}
    >
      <BottomSheetView>
        <View className="bg-teachLoop-creamBase rounded-t-[20]">
          <View className="h-6" />
          <View className="mx-5 flex-row justify-between">
            <Text className="font-geologica-medium text-black text-xl leading-[1.5] flex-1">
              Additional learning needs
            </Text>
            <Pressable onPress={onClose} className="active:opacity-80">
              <CloseIcon
                className="size-6"
                pathClassName="stroke-teachLoop-textPrimary"
              />
            </Pressable>
          </View>
          <View className="h-6" />

          <View className="mx-5">
            <Text className="font-geologica-regular text-black text-base leading-[1.5]">
              {additionalLearningNeeds}
            </Text>
          </View>
          <View className="h-8" />
        </View>
      </BottomSheetView>
    </BottomSheet>
  ) : null;
}

export default AdditionalLearningSheet;
